import type { DeepPartial } from '@luna/utils-ts';

import type { TitleDetail } from '../../types/TitleDetail';

export const titleDetailROConfig: DeepPartial<TitleDetail> = {
    applyDirectUrlToTitleDetails: false,
    displayPositionPiecesQuantity: true,
    formatStockExchangeValue: false,
    showCapitalGainsTax: false,
    findMatchingHeldTitles: true,
};
